import { render, staticRenderFns } from "./ThirPartPay.vue?vue&type=template&id=0956333e&scoped=true&"
import script from "./ThirPartPay.vue?vue&type=script&lang=js&"
export * from "./ThirPartPay.vue?vue&type=script&lang=js&"
import style0 from "./ThirPartPay.vue?vue&type=style&index=0&id=0956333e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0956333e",
  null
  
)

export default component.exports